module.exports = "/images/close.svg?9cd5594e7291ddad9757e9a7a8edf9b6";